import { createClient } from '@supabase/supabase-js';

const URL = import.meta.env.VITE_SUPABASE_URL;
const KLJUC = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!URL || !KLJUC) {
  throw new Error(
    'Nedostaju VITE_SUPABASE_URL i VITE_SUPABASE_ANON_KEY. ' +
      'Kopiraj .env.example u .env i popuni vrijednosti.'
  );
}

export const supabase = createClient(URL, KLJUC, {
  auth: { persistSession: true, autoRefreshToken: true }
});
